import React from 'react';
import { Col, Row } from 'reactstrap';
import IconOne from './svgs/IconOne';
import IconTwo from './svgs/IconTwo';
import IconThree from './svgs/IconThree';
import IconFour from './svgs/IconFour';
import { Card } from "@shopify/polaris";

const reasonConfig = [
    {
        title: "20% Recurring Commission",
        description: `<span>You will get a 20% commission for each new transaction as long as the referral is active.</span>`,
        icon: <IconOne />
    },
    {
        title: "Easy to start ",
        description: `<span>Sign-up takes less than 1 minute and is <b>completely free</b>.</span>`,
        icon: <IconTwo />
    },
    {
        title: "30 cookie days",
        description: `<span>If someone clicks your link and signs up within 30 days, you get the credit.</span>`,
        icon: <IconThree />
    },
    {
        title: "Intuitive Dashboard",
        description: `<span>Easy-to-use dashboards to launch, manage and monitor campaigns</span>`,
        icon: <IconFour />
    }
]

const Reasons = () => {
    return (
        <div className="st-affiliate-reasons">
            <Card
                title="Reasons to become a Synctrack affiliate"
            >
                <Card.Section>
                    <Row>
                        {reasonConfig.map((item, index) => (
                            <Col md={6} key={index} className="st-affiliate-reasons-item">
                                {item.icon}
                                <div>
                                    <h5>{item.title}</h5>
                                    <div dangerouslySetInnerHTML={{__html: item.description}}></div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Card.Section>
            </Card>
        </div>
    );
};

export default Reasons;